import {
  defaultRedirect,
  handleAuthError,
  handleJwt,
  handleNoAuth,
  handlePendingValidation,
  handleSessionExpired,
  handleUserLoading
} from "./auth-helper";
import { Outlet } from "react-router-dom";
import type { AuthStatuses } from "@dealer-center/ddc-api-auth-fetch";

interface AuthProps {
  redirect?: (url: string) => void;
  jwtToken?: string | null;
  auth: {
    authStatus: AuthStatuses;
    isAuthLoading: boolean;
  };
  user: {
    isLoading: boolean;
  };
}

export const Auth = ({
  auth,
  user,
  redirect = defaultRedirect,
  jwtToken
}: AuthProps) => {
  const { isAuthLoading, authStatus } = auth;
  const { isLoading: isUserLoading } = user;
  const jwt = getJwtToken(jwtToken);
  if (jwt) return handleJwt(jwt, redirect);
  if (isUserLoading) return handleUserLoading();
  if (isAuthLoading) return handlePendingValidation();
  if (authStatus === "ERROR") return handleAuthError();
  if (authStatus === "UNAUTHENTICATED") return handleNoAuth(redirect);
  if (authStatus === "LOGGEDOUT") return handleSessionExpired(redirect);
  if (!authStatus) return null;
  return <Outlet />;
};

function getJwtToken(jwtToken: string | null | undefined) {
  const currentURL = new URL(window.location.href);

  const jwt =
    jwtToken !== undefined
      ? jwtToken
      : currentURL.searchParams.get("__jwt_session");
  return jwt;
}
